import { Button } from "../Button";
import styles from "./footerButtons.module.scss";
import classnames from "classnames/bind";

const classNameBuilder = classnames.bind(styles);

export const FooterButtons = ({
  className,
  cancelClassName,
  submitClassName,
  disablePadding,

  onCancel,
  onSubmit,

  cancelText = "Cancel",
  submitText = "Submit",

  submitDisabled,

  cancelButtonProps,
  submitButtonProps,
}) => {
  return (
    <div
      className={classNameBuilder("container", className, {
        "no-padding": disablePadding,
      })}
    >
      {onCancel && (
        <Button
          className={classNameBuilder("button", cancelClassName)}
          onClick={onCancel}
          {...cancelButtonProps}
        >
          {cancelText}
        </Button>
      )}
      {onSubmit && (
        <Button
          className={classNameBuilder("button", submitClassName)}
          onClick={onSubmit}
          disabled={submitDisabled}
          {...submitButtonProps}
        >
          {submitText}
        </Button>
      )}
    </div>
  );
};
